import { EventActionType } from './event-action-type';

export interface RemoveAllEventOccurrenceAction {
  eventKey: string;
  type: EventActionType.RemoveAllOccurrences;
}

export const removeAllEventOccurrences = (
  eventKey: string,
): RemoveAllEventOccurrenceAction => ({
  eventKey,
  type: EventActionType.RemoveAllOccurrences,
});
